/**
 * Site footer — explore + legal. Keep light; primary CTA stays in Navbar.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { clearAnalyticsConsentCookie } from '../utils/consent';

const EXPLORE_LINKS = [
  { to: '/start', labelKey: 'nav.startWizard' as const },
  { to: '/solutions', labelKey: 'nav.solutions' as const },
  { to: '/faq', labelKey: 'nav.faq' as const },
  { to: '/blog', labelKey: 'nav.blog' as const },
  { to: '/pricing', labelKey: 'nav.pricing' as const },
  { to: '/how-it-works', labelKey: 'nav.howItWorks' as const },
  { to: '/why-us', labelKey: 'nav.whyUs' as const },
  { to: '/roadmap', labelKey: 'nav.roadmap' as const },
  { to: '/contact', labelKey: 'nav.contact' as const },
] as const;

const SiteFooter: React.FC = () => {
  const { t } = useTranslation();

  const resetCookies = () => {
    clearAnalyticsConsentCookie();
    window.location.href = '/';
  };

  return (
    <footer className="mt-auto border-t border-white/10 bg-dark-surface/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col gap-4 text-xs text-gray-500">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-gray-500">
            © {new Date().getFullYear()} Architect-IQ
          </p>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-2" aria-label={t('nav.explore', 'Explore')}>
            {EXPLORE_LINKS.map(({ to, labelKey }) => (
              <Link key={to} to={to} className="hover:text-gray-300 transition-colors">
                {t(labelKey)}
              </Link>
            ))}
          </nav>
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:justify-end" aria-label="Legal">
          <Link to="/privacy" className="hover:text-gray-300 transition-colors">
            {t('nav.privacy', 'Privacy')}
          </Link>
          <Link to="/cookies" className="hover:text-gray-300 transition-colors">
            {t('nav.cookies', 'Cookies')}
          </Link>
          <button
            type="button"
            onClick={resetCookies}
            className="hover:text-gray-300 transition-colors text-left"
          >
            {t('forms.consent.cookie_settings', 'Cookie settings')}
          </button>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;
